<template>
  <div class="student-box">
    <appHeader />
    <div class="header-bg">
      <img
        class="mountain"
        src="@/assets/studentImages/mountain.png"
        alt=""
      >
    </div>
    <!-- 学生成长档案 -->
    <div class="student-portfolio">
      <div class="student-portfolio-container">
        <img
          class="portfolio-title"
          src="@/assets/studentImages/portfolio-text.png"
          alt=""
        >
        <img
          class="portfolio-header"
          src="@/assets/studentImages/student-info.png"
        >
        <!-- 心理成长 -->
        <div class="mental-growth box-style">
          <div class="box-title">
            <img
              class="box-title-icon"
              src="@/assets/studentImages/grow-icon.png"
            >
            <div class="box-title-text">
              心理成长
            </div>
          </div>
          <div class="mental-growth-main">
            <div class="mental-growth-main-status growth-box">
              <div class="growth-box-title">
                心理状态
              </div>
              <div
                id="statusEchart"
                style="width: 2rem; height: 1.10708rem;"
              />
            </div>
            <div class="mental-growth-main-guidance growth-box">
              <div class="growth-box-title">
                心理辅导
              </div>
              <div class="guidance-box">
                <div
                  v-for="(item,i) in guidanceList"
                  :key="i"
                  class="guidance-box-item"
                >
                  <img
                    :src="item.icon"
                    alt=""
                  >
                  <div class="guidance-box-item-text text">
                    {{ item.mainText }}
                  </div>
                  <div>
                    <span class="guidance-box-item-count">{{ item.count }}</span>
                    <span class="text">次</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mental-growth-main-focus growth-box">
              <div class="growth-box-title">
                自我关注
              </div>
              <div class="focusradar">
                <div id="focusradarEchart" />
              </div>
            </div>
          </div>
        </div>
        <div class="practice">
          <div class="practice-press box-style">
            <div class="box-title">
              <img
                class="box-title-icon"
                src="@/assets/studentImages/press-icon.png"
              >
              <div class="box-title-text">
                压力源与压力程度
              </div>
              <div class="box-title-subtext">
                数据来源：近一个月的自主互动测评及心理健康测评结果
              </div>
            </div>
            <div
              id="pressEachts"
              style="width: 3.3125rem; height: 1.40625rem;"
            />
            <div class="box-footer">
              该生当前的主要压力来源于学习、情绪、升学三个当面，其中相关的学业情绪、学习适应、情绪控制、学业生涯登维度的压力程度较高。
            </div>
          </div>
          <div class="practice-self box-style">
            <div class="box-title">
              <img
                class="box-title-icon"
                src="@/assets/studentImages/self-practice-icon.png"
              >
              <div class="box-title-text">
                自主互动练习
              </div>
            </div>
            <WordCloud />
            <div class="box-footer">
              目前学生主要关注的主题是升学途径、生涯探索、学业状态、人际关系等方面的内容，说明该生可能存在这些方面的问题，老师可以重点关注该生在这些方面的行为和情绪表现。
            </div>
          </div>
        </div>
        <!-- 资源推荐 -->
        <div class="resource-recommendment box-style">
          <div class="box-title">
            <img
              class="box-title-icon"
              src="@/assets/studentImages/self-practice-icon.png"
            >
            <div class="box-title-text">
              资源推荐
            </div>
            <div class="box-title-subtext">
              根据学生当前的心理状态和压力源与压力程度的分析，制定了7天打卡训练计划和心理科普知识
            </div>
          </div>
          <!-- <img src="@/assets/studentImages/resource-recommendment.png"> -->
        </div>
        <!-- 心理科普知识推荐 -->
        <div class="popular-knowledge box-style">
          <div class="box-title">
            <img
              class="box-title-icon"
              src="@/assets/studentImages/recommendment-icon.png"
            >
            <div class="box-title-text">
              心理科普知识推荐
            </div>
          </div>
          <!-- <div class="popular-knowledge-title">
        心理科普知识推荐
      </div> -->
          <div class="popular-knowledge-content">
            <div
              v-for="(item,i) in popularnowledgelist"
              :key="i"
              class="popular-knowledge-content-item"
            >
              <video
                :id="'showVideo' + i"
                :ref="'oldVideo' + i"
                preload="auto"
                controlslist="nodownload"
                :poster="item.img"
                height="125px"
                muted
                :src="item.videoSrc"
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="true"
                controls
              />
              <div class="push-btn">
                一键推送
              </div>
              <div class="main-text">
                {{ item.mainText }}
              </div>
              <div class="sub-text">
                {{ item.subText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="student-cloud" />
  </div>
</template>
<script>
import {
  radarEcharts,
  psychologicalLineEcharts,
  pressBarEcharts
} from "./growthPortfolioEchats.js";
import { growthPortfolioData } from '@/assets/data.js';
import WordCloud from "@/components/wordCloud.vue";
import AppHeader from "@/components/appHeader";
export default {
  components: {
    WordCloud,
    AppHeader
  },
  data () {
    return {
      popularnowledgelist: growthPortfolioData.popularnowledgelist,
      // 心理辅导数据
      guidanceList: [{
        icon: require('../assets/studentImages/guidance-icon1.png'),
        mainText: '自主测评',
        count: '38'
      }, {
        icon: require('../assets/studentImages/guidance-icon2.png'),
        mainText: '互动减压',
        count: '25'
      }, {
        icon: require('../assets/studentImages/guidance-icon3.png'),
        mainText: '预警次数',
        count: '12'
      }, {
        icon: require('../assets/studentImages/guidance-icon4.png'),
        mainText: '咨询次数',
        count: '9'
      }],
    }
  },
  mounted () {
    psychologicalLineEcharts(this.$echarts, 'statusEchart')
    radarEcharts(this.$echarts)
    pressBarEcharts(this.$echarts, 'pressEachts')
  }
}
</script>
<style lang="scss" scoped>
.student-box {
  position: relative;
  width: 100%;
  background: #f1f7ff;
  .header-bg {
    position: absolute;
    left: 0;
    top: 58px;
    width: 100%;
    height: 285px;
    background: url("../assets/studentImages/header-bg.png") 0 0 /100% 100%;
    // z-index: -999;
  }
  .mountain {
    position: absolute;
    top: 261px;
    left: 182px;
    width: 97px;
    height: 78px;
  }
  .student-cloud {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 307.5px;
    background: url("../assets/studentImages/main-footer-bg.png") 0 0 /100% 100%;
  }
}
.student-portfolio {
  position: relative;
  z-index: 1;
  // overflow-x: hidden;
  width: 100%;
  min-height: 100%;
  .student-portfolio-container {
    width: 1200px;
    margin: 0 auto;
  }
  .portfolio-title {
    // position: absolute;
    width: 249px;
    height: 40px;
    margin-top: 72px;
  }
  .portfolio-header {
    width: 100%;
    // width: 1200px;
    height: 182px;
    margin: 35px 0 24px 0;
  }
  .mental-growth {
    width: 100%;
    // width: 1200px;
  }
  .mental-growth-main {
    display: flex;
    .growth-box {
      width: 384px;
      height: 262px;
      border-radius: 4px;
      border: 1px solid #eaeaea;
      padding: 16px 20px;
      .growth-box-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #000000;
      }
    }
    .mental-growth-main-status {
      // margin-right: 22px;
      padding: 16px 0;
      .growth-box-title {
        padding: 0 20px;
      }
    }
    .mental-growth-main-guidance {
      // background: url("../assets/studentImages/mental-guidance.png") 0 0 /100% 100%;
      width: 386px;
      height: 264px;
      margin: 0 22px;
      .guidance-box {
        display: flex;
        justify-content: space-between;
        margin-top: 51px;
        .guidance-box-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
          }
          .guidance-box-item-text {
            margin: 15px 0 12px 0;
          }
          .text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #595959;
          }
          .guidance-box-item-count {
            font-size: 16px;
            font-family: Helvetica;
            color: #333333;
          }
        }
      }
    }
    .mental-growth-main-focus {
      width: 360px;
    }
    #statusEchart {
      width: 380px;
      height: 200px;
    }
    .focusradar {
      width: 320px;
      height: 220px;
      #focusradarEchart {
        width: 100%;
        height: 100%;
      }
    }
  }
  .practice {
    display: flex;
    margin: 24px 0;
    .practice-press {
      width: 636px;
      height: 425px;
      margin-right: 19px;
    }
    .practice-self {
      width: 542px;
      height: 424px;
    }
    #pressEachts {
      width: 636px;
      height: 270px;
    }
  }
  .resource-recommendment {
    width: 100%;
    // width: 1200px;
    height: 383px;
    background: url("../assets/studentImages/resource-recommendment.png") 0 0 /100%
      100%;
  }
  .popular-knowledge {
    width: 100%;
    // width: 1200px;
    height: 278px;
    margin-top: 24px;
    .popular-knowledge-content {
      display: flex;
      justify-content: space-between;
      .popular-knowledge-content-item {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 221px;
        .push-btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 72px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          background: #000000;
          border-radius: 8px 0px 8px 0px;
          opacity: 0.5;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffffff;
        }
      }
      video {
        width: 221px;
        height: 125px;
      }
      .main-text {
        margin: 9px 0 3px 0;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #000000;
        // line-height: 20px;
      }
      .sub-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        // line-height: 17px;
      }
    }
  }
}
.box-style {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  .box-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .box-title-icon {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
    .box-title-text {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
    }
    .box-title-subtext {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #262626;
      margin-left: 12px;
    }
  }
  .box-footer {
    background: #f0f7ff;
    border-radius: 15px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #595959;
    line-height: 20px;
    padding: 16px 22px;
  }
}
</style>